var _path, _path2, _circle, _circle2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmartDocsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 1C2.44772 1 2 1.44772 2 2V20C2 20.5523 2.44772 21 3 21H17C17.5523 21 18 20.5523 18 20V7L12 1H3Z",
    fill: "transparent",
    stroke: "#3E97FF",
    strokeWidth: 1.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 1V7H18",
    fill: "transparent",
    stroke: "#3E97FF",
    strokeWidth: 1.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 3,
    fill: "#3E97FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 11,
    r: 1.2,
    fill: "3E97FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.25,
    x: 2,
    y: 18,
    width: 16,
    height: 3,
    rx: 1.5,
    fill: "#3E97FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartDocsIcon);
export default __webpack_public_path__ + "static/media/SmartDocs-Icon.faeeb12337be57c89f6008472fe568ea.svg";
export { ForwardRef as ReactComponent };